import React from "react";
import Confetti from "react-confetti";

export const CustomizedConfetti = (props) => {
  const windowWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;

  return props.showConfetti ? (
    <Confetti
      numberOfPieces={800}
      width={windowWidth}
      height={document.documentElement.scrollHeight}
      recycle={false}
      confettiSource={{
        x: 0,
        y: window.scrollY,
        w: windowWidth,
        h: 0,
      }}
    />
  ) : (
    ""
  );
};
